import React, { useEffect, useState, FC } from "react";
import { Box, Button, Grid, Typography, CircularProgress } from "@material-ui/core";
import IrancellIcon from "../../../../../assets/images/irancell-icon.svg";
import HamrahAvalIcon from "../../../../../assets/images/hamrahAvalIcon.svg";
import RightelIcon from "../../../../../assets/images/rightelIcon.svg";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useDispatch, useSelector } from "react-redux";
import { SetChargePackage } from "../../../../../redux/chargePackage/actions";
import { useHistory } from "react-router-dom";
import { opratorSelector } from "../../../../../utils/opratorSelector";
import CustomInputNumber from "../../../../../components/input-number";
import { phoneMobileInquiryApi } from "../../../../../services/api/bill"

interface componentProps {
    text: string
    icon: any
}

const BillPhone: FC<componentProps> = ({ text, icon }) => {
    const [loading, setLoading] = useState(false)
    const [formValue, setFormValue] = useState<any>({
        line_number: undefined,
        operator_id: undefined,
    });
    const [formErr, setFormErr] = useState<any>({});
    const dispatch = useDispatch();
    const history = useHistory();
    const { info: { billType } } = useSelector(({ payment }: any) => payment)

    useEffect(() => {
        let op = opratorSelector(formValue["line_number"]);
        setFormValue({
            ...formValue,
            operator_id: op,
        });
    }, [formValue["line_number"]]);

    const handleFormValue = ({ target: { name, value } }: any) => {
        setFormValue({
            ...formValue,
            [name]: value,
        });
    };

    const handleButton = (name: string, value: any) => {
        setFormValue({
            ...formValue,
            [name]: value,
        });
    };

    const validate = (submit: any) => {
        let _errors = {};
        let hasError = false;
        Object.keys(formValue).map((item: any) => {
            // @ts-ignore
            if (!formValue[item]) {
                _errors = { ..._errors, [item]: "این فیلداجباری است" };
                hasError = true;
            } else if (formValue['line_number']?.slice(0, 2) !== "09") {
                _errors = { ..._errors, ['line_number']: "شماره موبایل باید با 09 شروع شود" }
                hasError = true
            }
        });
        setFormErr(_errors);
        if (!hasError) submit();
    };

    const valid = ({ target: { name, value } }: any) => {
        let event = {
            target: {
                name: name,
                value: value,
            },
        };
        switch (name) {
            case "line_number":

                if (value.length < 12) {
                    handleFormValue(event);
                }

                break;
            default:
                handleFormValue(event);
        }
    };

    const onSubmit = async () => {
        console.log('submit')
        setLoading(true)
        const res = await phoneMobileInquiryApi({
            ...formValue,
        })
        if (res) {
            dispatch(SetChargePackage({ ...formValue, ...res, billType }));
            history?.push("/billDetails")
        }
        setLoading(false)
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {/* @ts-ignore */}
                    <Box display={"flex"} justifyContent="center" alignItems="center" mb={2}>
                        <img src={icon} alt="" className='headIcon' />
                        <Typography>
                            {text}
                        </Typography>
                    </Box>
                    <hr style={{ marginBottom: '20px' }} />
                    <Typography className="text-muted text-right small">
                        شماره موبایل خود را وارد کنید
                    </Typography>
                    <CustomInputNumber
                        placeholder="09"
                        type={"number"}
                        name="line_number"
                        variant="outlined"
                        className="w-100 my-3"
                        size="small"
                        onChange={valid}
                        // autocomplete={"on"}
                        value={formValue["line_number"]}
                    />
                    <Typography className="textError">
                        {formErr && formErr["line_number"]}
                    </Typography>
                </Grid>
                <Grid item xs={4} className="op-res">
                    {/* @ts-ignore */}
                    <Box p={1} display="flex" justifyContent="center" className="flexi">
                        <Button
                            variant="contained"
                            className={`btn ${formValue["operator_id"] === 1 ? "Active" : ""
                                } btn-res`}
                            onClick={() => handleButton("operator_id", 1)}
                        >
                            <img src={IrancellIcon} width="60px" className="img-res" />
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={4} className="op-res">
                    {/* @ts-ignore */}
                    <Box p={1} display="flex" justifyContent="center" className="flexi">
                        <Button
                            variant="contained"
                            className={`btn ${formValue["operator_id"] === 2 ? "Active" : ""
                                } btn-res`}
                            onClick={() => handleButton("operator_id", 2)}
                        >
                            <img src={HamrahAvalIcon} width="60px" className="img-res" />
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={4} className="op-res">
                    {/* @ts-ignore */}
                    <Box p={1} display="flex" justifyContent="center" className="flexi">
                        <Button
                            variant="contained"
                            className={`btn ${formValue["operator_id"] === 3 ? "Active" : ""
                                } btn-res`}
                            onClick={() => handleButton("operator_id", 3)}
                        >
                            <img src={RightelIcon} width="60px" className="img-res" />
                        </Button>
                    </Box>
                </Grid>
                {formErr["operator_id"] && (
                    <Grid item xs={12}>
                        <Typography className="textError">
                            {formErr["operator_id"]}
                        </Typography>
                    </Grid>
                )}
            </Grid>

            <Grid container className="m-0">

                <Grid item>
                    <InfoOutlinedIcon color="secondary" className="resize ml-2" />
                </Grid>
                <Grid item justifyContent="flex-end">
                    <Typography className="small text-center text-muted">
                        در صورتی که ترابرد کرده اید اپراتور خود را تغییر دهید
                    </Typography>
                </Grid>

            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    {/*<input type="submit" className="w-100 round-btn mt-5"*/}
                    {/*       color="primary" value="ادامه"/>*/}

                    <Button
                        variant="contained"
                        className="w-100 text-white typeBackground round-btn mt-4"
                        size="large"
                        onClick={() => validate(onSubmit)}
                        disabled={loading ? true : false}
                    >
                        {loading ? <CircularProgress color="inherit" style={{ width: '20px', height: '20px', marginBottom: '-6px' }} /> : "استعلام"}
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}


export default BillPhone